<template>
    <v-container>
        <v-row class="mt-15">
            <v-col cols="12" md="8" offset-md="2" lg="6" offset-lg="3" xl="4" offset-xl="4">
                <v-row>
                    <v-col cols="12">
                        <div class="white-card kimsa-elevation pa-0">
                            <card-creator ref="cardCreator" @success="onCreateSuccess" @error="onCreateError"/>
                        </div>
                    </v-col>
                    <v-col cols="12" class="mt-5">
                        <v-alert icon="mdi-alert-circle-outline" dark color="error" border="left">
                            <div v-html="currentError"/>
                        </v-alert>
                    </v-col>
                    <v-col cols="12" align="center">
                        <logout-button small outlined/>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import CardCreator from "@/components/common/payment/CardCreator";
import {db} from "@/utils/Firebase";
import LogoutButton from "@/components/common/inputs/LogoutButton";
import {mapActions} from "vuex";

export default {
    name: "CreditCard",
    components: {LogoutButton, CardCreator},
    computed: {
        paymentMethodDeleted(vm = this) {
            return vm.$route.query.deleted === 'true'
        },
        currentError(vm = this) {
            if (vm.paymentMethodDeleted) return vm.$t('coach.payment_method_declined')
            let last4 = vm.account?.stripeAccount?.last4 || null
            let defaultMessage = vm.$t('payment_failed_messages.try_again_later')
            let failedReason = vm.account?.stripeAccount?.failedReason || null
            let reason = vm.$te(`payment_failed_messages.${failedReason}`) ?
                vm.$t(`payment_failed_messages.${failedReason}`) : defaultMessage
            if (last4) return vm.$t('payment_failed_messages.last_card', {last4}) + '<br>' + reason
            return vm.$t('coach.payment_method_required')
        },
    },
    methods: {
        async onCreateSuccess({paymentMethod}) {
            // console.log('paymentMethod', paymentMethod)
            const vm = this

            if (vm.account) {
                const {card, billing_details, id} = paymentMethod

                let paymentPayload = {
                    id: id,
                    billing_details: {name: billing_details.name},
                    card: {
                        brand: card.brand,
                        last4: card.last4
                    }
                }

                const payload = {
                    'stripeAccount.paymentMethod': paymentPayload,
                    'stripeAccount.failedReason': '',
                    'stripeAccount.last4': null,
                }

                await db.collection('users').doc(vm.currentUser.uid).update(payload)

                await vm.bindUserAccount(vm.currentUser)

                if (!vm.account?.stripeAccount?.currentSubscription?.id)
                    await vm.$router.push({name: 'company.select-plan'})
            }
        },
        onCreateError(error) {
            console.log('error', error)
        }
    },
}
</script>

<style scoped>

</style>
